import React, { useState, useEffect } from 'react';
import WidgetWrapper from './WidgetWrapper';
import { analytics } from '../../services/api';

const AnalyticsWidget = ({ darkMode = false, onError }) => {
  const [realtimeData, setRealtimeData] = useState(null);
  const [historyData, setHistoryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showHistory, setShowHistory] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [realtimeRes, historyRes] = await Promise.all([
          analytics.get(),
          analytics.getHistory()
        ]);
        setRealtimeData(realtimeRes.data);
        setHistoryData(historyRes.data);
      } catch (error) {
        console.error('AnalyticsWidget error:', error);
        onError?.('AnalyticsWidget', error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [onError]);

  const textColor = darkMode ? '#f3f4f6' : '#111827';
  const subColor = darkMode ? '#9ca3af' : '#6b7280';

  return (
    <WidgetWrapper title="📊 Google Analytics" loading={loading} darkMode={darkMode}>
      <div style={{ marginBottom: 12 }}>
        <button
          onClick={() => setShowHistory(!showHistory)}
          style={{
            padding: '4px 12px',
            fontSize: 12,
            background: showHistory ? '#3b82f6' : '#e5e7eb',
            color: showHistory ? 'white' : '#374151',
            border: 'none',
            borderRadius: 4,
            cursor: 'pointer'
          }}
        >
          {showHistory ? '📈 Showing 30 Days' : '📱 Realtime'}
        </button>
      </div>

      {showHistory && historyData ? (
        // 30-Day History View
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 16 }}>
            <div style={{ textAlign: 'center', padding: 8, background: darkMode ? '#1f2937' : '#f3f4f6', borderRadius: 8 }}>
              <div style={{ fontSize: 20, fontWeight: 'bold', color: textColor }}>{historyData.totalViews || 0}</div>
              <div style={{ fontSize: 11, color: subColor }}>Views (30d)</div>
            </div>
            <div style={{ textAlign: 'center', padding: 8, background: darkMode ? '#1f2937' : '#f3f4f6', borderRadius: 8 }}>
              <div style={{ fontSize: 20, fontWeight: 'bold', color: textColor }}>{historyData.totalUsers || 0}</div>
              <div style={{ fontSize: 11, color: subColor }}>Users (30d)</div>
            </div>
            <div style={{ textAlign: 'center', padding: 8, background: darkMode ? '#1f2937' : '#f3f4f6', borderRadius: 8 }}>
              <div style={{ fontSize: 20, fontWeight: 'bold', color: textColor }}>{historyData.totalSessions || 0}</div>
              <div style={{ fontSize: 11, color: subColor }}>Sessions (30d)</div>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <div style={{ fontSize: 12, fontWeight: 'bold', color: textColor, marginBottom: 8 }}>🌍 Top Countries</div>
              {(historyData.topCountries && historyData.topCountries.length > 0) ? historyData.topCountries.slice(0, 5).map((c, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '4px 0', borderBottom: '1px solid ' + (darkMode ? '#374151' : '#e5e7eb') }}>
                  <span style={{ color: textColor }}>{c.name}</span>
                  <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>{c.views}</span>
                </div>
              )) : <div style={{ textAlign: 'center', padding: 20, color: subColor }}><span style={{ fontSize: 24, display: 'block', marginBottom: 8 }}>📊</span><span style={{ fontSize: 12 }}>No analytics data</span></div>}
            </div>
            <div>
              <div style={{ fontSize: 12, fontWeight: 'bold', color: textColor, marginBottom: 8 }}>🏙️ Top Cities</div>
              {(historyData.topCities && historyData.topCities.length > 0) ? historyData.topCities.slice(0, 5).map((c, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, padding: '4px 0', borderBottom: '1px solid ' + (darkMode ? '#374151' : '#e5e7eb') }}>
                  <span style={{ color: textColor }}>{c.name}</span>
                  <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>{c.views}</span>
                </div>
              )) : <div style={{ textAlign: 'center', padding: 20, color: subColor }}><span style={{ fontSize: 24, display: 'block', marginBottom: 8 }}>📊</span><span style={{ fontSize: 12 }}>No analytics data</span></div>}
            </div>
          </div>


        </div>
      ) : (
        // Realtime View
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 32, fontWeight: 'bold', color: textColor }}>{realtimeData?.activeUsers || 0}</div>
            <div style={{ fontSize: 12, color: subColor }}>Active Users</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 32, fontWeight: 'bold', color: textColor }}>{realtimeData?.pageViewsToday || 0}</div>
            <div style={{ fontSize: 12, color: subColor }}>Page Views Today</div>
          </div>
        </div>
      )}
    </WidgetWrapper>
  );
};

// Widget metadata
AnalyticsWidget.widgetId = 'analytics';
AnalyticsWidget.title = '📊 Google Analytics';
AnalyticsWidget.defaultSize = { cols: 6 };
AnalyticsWidget.category = 'business';

export default AnalyticsWidget;